module["exports"] = ["# דירה", "## דירה", "# חדר", "## חדר"];